import type { LucideIcon } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import './SettingsSidebar.css'

export interface SettingsNavItem {
  to: string
  label: string
  icon: LucideIcon
  /** The badge's color, from design.md section 9's settings tabs reference. */
  color: string
  /** The icon's color on the badge: white unless the badge is light. */
  iconColor?: string
}

/**
 * A macOS System Settings sidebar (design.md 8.2): each item's icon sits in a small colored
 * rounded-square badge, and the current one has a filled background. Items are links, so
 * each section has its own address.
 */
export function SettingsSidebar({ title, items }: { title: string; items: SettingsNavItem[] }) {
  return (
    <nav className="settings-sidebar" aria-label={title}>
      <div className="settings-sidebar-title">{title}</div>
      {items.map((item) => (
        <NavLink key={item.to} to={item.to} className="settings-nav-item">
          <span className="settings-nav-icon" style={{ background: item.color, color: item.iconColor ?? '#fff' }} aria-hidden="true">
            <item.icon />
          </span>
          <span className="settings-nav-label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
